exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-27c78030] .md-menu-content.md-select-menu {\n  width: 150px;\n}\n.modal-container[data-v-27c78030] {\n  max-width: 600px;\n}\n[data-v-27c78030] .time-picker .vs__search:focus {\n  min-width: 135px !important;\n}\n.tag-padding[data-v-27c78030] {\n  padding-bottom: 20px;\n}\n", ""]);

// exports
